export default "__VITE_ASSET__kAx2ZTzx__"